import {
	RolesEndpoint,
	RolesEndpointRoutes
} from './roles-permissions.interface';

export class RolesEndpointFactory 
{
	public static build(baseUrl: string): RolesEndpoint 
	{
		return {
			baseUrl: baseUrl,
			routes: this.buildRoutes(baseUrl)
		};
	}
	private static buildRoutes(baseUrl: string): RolesEndpointRoutes 
	{
		return {
			roles: {
				toString: () => `${baseUrl}v0/api`,
				getRoles: {
					toString: () => `${baseUrl}v0/role/details`,
					addRoles: {
						toString: () => `${baseUrl}v0/role/create`
					},
					update: {
						toString: () => `${baseUrl}v0/role/update`
					},
					getRemoveRoleState: {
						toString: () => `${baseUrl}v0/role/AEMremoveLabels`
					},
					delete: {
						toString: () => `${baseUrl}v0/role/`
					}
				}
			}
		} as RolesEndpointRoutes;
	}
}
